export default "__VITE_PUBLIC_ASSET__5a8e5865__"